import React, { useEffect } from 'react';
import { Card, Table, TablePaginationConfig } from 'antd';
import Column from 'antd/lib/table/Column';
import api from '@services/api';
import { NumberOfDevicesPerTagItem } from '@openapi';
import { StbGroupExtended } from '@services/types';
import { AppContext } from '@layouts/AppRouter';
import { Navigation } from '@constants/Navigation';
import { useHistory } from 'react-router-dom';

const Tags = () => {
  const { setDeviceTagsFilter } = React.useContext(AppContext);
  const history = useHistory();
  const [tags, setTags] = React.useState<any>([]);
  const [deviceTags, setDeviceTags] = React.useState<NumberOfDevicesPerTagItem | any>([]);
  const [isLoading, setIsLoading] = React.useState(true);

  useEffect(() => {
    Promise.all([api.tags.getDeviceTags()]).then(([deviceTags]) => {
      setDeviceTags(deviceTags);
      setTags(tags);
      setIsLoading(false);
    });
  }, []);
  const data: any = Array.from(deviceTags || []).map((item) => item);
  return (
    <Card title="Tags" bodyStyle={{ padding: 0 }}>
      <Table dataSource={data} loading={isLoading}>
        <Column title="Name" dataIndex="tag" key="tag" />
        <Column
          title="Number Of Devices"
          dataIndex="numberOfDevices"
          render={(_text, record: NumberOfDevicesPerTagItem) => (
            <span
              style={{ color: '#00a9f7', cursor: 'pointer', fontWeight: '500' }}
              onClick={() => {
                setDeviceTagsFilter(record.tag);
                history.push(Navigation.Devices);
              }}
            >
              {record.number}
            </span>
          )}
        />
      </Table>
    </Card>
  );
};

export default React.memo(Tags);
